import { Component, Input, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-info-button',
  template: `
    <button class="info-button" (click)="toggleModal()" aria-label="Dodatne informacije">
      <img src="assets/img/info-icon.png" alt="Info" class="info-icon">
    </button>
    <div *ngIf="showModal" class="modal-content">
      <span class="close-button" (click)="toggleModal()">×</span>
      <p>{{ infoText }}</p>
    </div>
  `,
  styles: [`
    :host {
      position: relative;
      display: inline-block;
    }
    .info-button {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      vertical-align: middle;
      margin-left:3px;
      margin-bottom:2px;
    }
    .info-icon {
      width: 16px;
      height: 16px;
    }
    .info-button:hover::after {
      content: 'Dodatne informacije';
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      background: #333;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      z-index: 1001;
    }
       .modal-content {
      position: absolute;
      top: 0;
      left: calc(100% + 8px);
      background:rgba(233, 244, 250, 0.95)  ;
      padding: 10px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      width: 160px;
      z-index: 1000;
      display: flex;
      align-items: flex-start;
      font-size: 12px;
      //margin-right: 8px;
    }
    .modal-content p {
      margin: 0;
      flex-grow: 1;
      margin-right: 3%;
    }
    .close-button {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
      font-size: 16px;
    }
  `]
})
export class InfoButtonComponent implements AfterViewInit {
  @Input() infoText: string = '';
  showModal: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Prilagođavanje položaja modala ako prelazi granice ekrana
    this.adjustModalPosition();
  }

  toggleModal() {
    this.showModal = !this.showModal;
    if (this.showModal) {
      setTimeout(() => this.adjustModalPosition(), 0);
    }
  }

  private adjustModalPosition() {
    if (!this.showModal) return;
    const modal = this.el.nativeElement.querySelector('.modal-content');
    if (!modal) return;

    const rect = modal.getBoundingClientRect();
    const buttonRect = this.el.nativeElement.querySelector('.info-button').getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    // Ako modal prelazi desnu granicu ekrana, pomakni ga lijevo od gumba
    if (rect.right > viewportWidth) {
      this.renderer.setStyle(modal, 'left', 'auto');
      this.renderer.setStyle(modal, 'right', `calc(100% + 8px)`);
    } else {
      this.renderer.setStyle(modal, 'left', `calc(100% + 8px)`);
      this.renderer.setStyle(modal, 'right', 'auto');
    }

    // Ako modal prelazi donju granicu ekrana, pomakni ga iznad gumba
    const viewportHeight = window.innerHeight;
    if (rect.bottom > viewportHeight) {
      this.renderer.setStyle(modal, 'top', `-${rect.height - buttonRect.height}px`);
    } else {
      this.renderer.setStyle(modal, 'top', '0');
    }
  }
}
